import { styled } from 'dripsy';
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { View } from 'react-native';

import { BaseText, Separator } from '@components';
import { useViewerModel } from '@models/Viewer/ViewerModel';

const Title = styled(BaseText)({
  textAlign: ['center', 'left'],
  variant: 'text.xlarge',
  color: '$heading800',
  fontWeight: 'semi',
});

const Subtitle = styled(BaseText)({
  textAlign: ['center', 'left'],
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  variant: ['text.medium', 'text.xlarge'],
  color: '$heading800',
  fontWeight: [null, 'semi'],
});

const Description = styled(BaseText)({
  textAlign: ['center', 'left'],
  variant: 'text.medium',
  color: '$text400',
});

export const ProgressTopText = observer(() => {
  const { t } = useTranslation();
  const viewer = useViewerModel();
  const watchProgress = viewer.userWatchProgress;

  const firstName = viewer.currentUser?.firstName;
  const shouldGreet = watchProgress.completionPercent >= 0.8;

  return (
    <View>
      {shouldGreet ? (
        <Fragment>
          <Title>{`${t('home.congrats')} 🎉 ${firstName}!`}</Title>
          <Separator size="$4" />
          <Description>
            {t('home.description', { context: 'greet' })}
          </Description>
        </Fragment>
      ) : (
        <Subtitle>{`${t('home.description')} 🚀`}</Subtitle>
      )}
    </View>
  );
});
